<template>
  <div class="reports-container" >
    <!-- :style="containerStyle" -->
    <!-- ===== Header ===== -->
    <!-- <div class="reports-header">
      <div class="header-content">

      <div class="header-menu">
        <ReportsMenu />
      </div>

      <div class="header-title">
        <h1 class="page-title">Reports</h1>
        <p class="page-subtitle">
          Detailed analytics and sales performance
        </p>
      </div>

        <div class="header-right">
          <button @click="goBack" class="btn-back">
            ← Back
          </button>
        </div>
      </div>
    </div> -->
    <AppHeader title="Reports" />

    <!-- ===== Content ===== -->
    <div class="reports-content">
      <div v-if="hasPermission(32)" class="section-title">
        <!-- <span>Reports</span> -->
      </div>

      <div v-if="!loading" class="reports-grid">

        <button
          v-if="hasPermission(33)"
          class="menu-card"
          @click="handleDailyTotals"
        >

          <div class="card-icon-wrapper">
            <img class="card-icon default-icon" :src="imgs[1]" alt="Products" />
            <img class="card-icon hover-icon" :src="imgs[12]" alt="Hover" />
          </div>
          <span class="card-label">Daily Totals</span>
        </button>

        <button
          v-if="hasPermission(34)"
          class="menu-card"
          @click="handleItemsDaily"
        >
          <div class="card-icon-wrapper">
            <img class="card-icon default-icon" :src="imgs[2]" alt="Products" />
            <img class="card-icon hover-icon" :src="imgs[0]" alt="Hover" />
          </div>
          <span class="card-label">Department Wise</span>
        </button>

        <button
          v-if="hasPermission(55)"
          class="menu-card"
          @click="handleDepItemsDaily"
        >          <div class="card-icon-wrapper">
            <img class="card-icon default-icon" :src="imgs[3]" alt="Products" />
            <img class="card-icon hover-icon" :src="imgs[4]" alt="Hover" />
          </div>
          <span class="card-label">Department Items</span>
        </button>

        <button
          v-if="hasPermission(35)"
          class="menu-card"
          @click="handleDailySales"
        >          <div class="card-icon-wrapper">
            <img class="card-icon default-icon" :src="imgs[5]" alt="Products" />
            <img class="card-icon hover-icon" :src="imgs[6]" alt="Hover" />
          </div>
          <span class="card-label">Daily Sales</span>
        </button>

        <button
          v-if="hasPermission(36)"
          class="menu-card"
          @click="handleCashierInvoices"
        >          
          <div class="card-icon-wrapper">
            <img class="card-icon default-icon" :src="imgs[7]" alt="Products" />
            <img class="card-icon hover-icon" :src="imgs[8]" alt="Hover" />
          </div>
          <span class="card-label">Cashier Invoices</span>
        </button>

        <button v-if="hasPermission(63)" class="menu-card" @click="handleCustomCloseCash">
            <div class="card-icon-wrapper">
              <!-- <span class="card-icon-emoji">🎁</span> -->
              <img class="card-icon" :src="imgs[15]">

            </div>
            <span class="card-label">{{ jsonData.custom_close_cash }}</span>
          </button>
        <button
          v-if="hasPermission(37)"
          class="menu-card"
          @click="handleCashierCash"
        >          <div class="card-icon-wrapper">
            <img class="card-icon default-icon" :src="imgs[9]" alt="Products" />
            <img class="card-icon hover-icon" :src="imgs[10]" alt="Hover" />
          </div>
          <span class="card-label">Cashier Cash</span>
        </button>

        <router-link
          v-for="report in filteredReports"
          :key="report.listName"
          :to="`/gen-reports?listname=${report.listName}`"
          class="menu-card link-card"
        >          <div class="card-icon-wrapper">
            <img class="card-icon default-icon" :src="imgs[11]" alt="Products" />
            <img class="card-icon hover-icon" :src="imgs[14]" alt="Hover" />
          </div>
          <span class="card-label">{{ report.showName }}</span>
        </router-link>
<!-- <router-link
  v-for="report in filteredReports"
  :key="report.listName"
  :to="`/gen-reports?listname=${report.listName}`"
  class="menu-card link-card"
>
  <div class="card-icon-wrapper">
    <img
      class="card-icon default-icon"
      :src="getReportIconByName(report.listName, 'default')"
      alt="Report Icon"
    />

    <img
      class="card-icon hover-icon"
      :src="getReportIconByName(report.listName, 'hover')"
      alt="Report Hover Icon"
    />
  </div>

  <span class="card-label">{{ report.showName }}</span>
</router-link> -->
      </div>
    </div>

    <!-- <div>
        <div class="list-group-item" v-if="hasPermission(32)"  style="background-color: #656565;border: solid 2px;border-style: outset;text-align:center"><div style="color:whitesmoke;font-size:1.5em"  onmouseover="this.style.backgroundColor='#656565';" href="#">Reports</div></div>              
        <table width="100%" align="center">
          <tr>
            <td>
              <li class="list-group-item" v-if="hasPermission(33)"  style="background-color: #656565;border: solid 2px;border-style: outset;text-align:center"><a style="color:whitesmoke"  onmouseover="this.style.backgroundColor='#656565'" href="#" @click="handleDailyTotals">Daily Totals</a></li>
            </td>
            <td>
              <li class="list-group-item" v-if="hasPermission(34)"  style="background-color: #656565;border: solid 2px;border-style: outset;text-align:center"><a style="color:whitesmoke"  onmouseover="this.style.backgroundColor='#656565'" href="#" @click="handleItemsDaily">Department Wise</a></li>              
            </td>
            <td>
              <li class="list-group-item" v-if="hasPermission(73)"  style="background-color: #656565;border: solid 2px;border-style: outset;text-align:center"><a style="color:whitesmoke"  onmouseover="this.style.backgroundColor='#656565'" href="#" @click="handleAllItemsDaily">Item Wise</a></li>              
            </td>
            <td>
              <li class="list-group-item" v-if="hasPermission(55)"  style="background-color: #656565;border: solid 2px;border-style: outset;text-align:center"><a style="color:whitesmoke"  onmouseover="this.style.backgroundColor='#656565'" href="#" @click="handleDepItemsDaily">Department Items</a></li>              
            </td>
            <td>
              <li class="list-group-item" v-if="hasPermission(35)"  style="background-color: #656565;border: solid 2px;border-style: outset;text-align:center"><a style="color:whitesmoke"  onmouseover="this.style.backgroundColor='#656565'" href="#" @click="handleDailySales">Daily Sales</a></li>              
            </td>
            <td>
              <li class="list-group-item" v-if="hasPermission(36)"  style="background-color: #656565;border: solid 2px;border-style: outset;text-align:left"><a style="color:whitesmoke"  onmouseover="this.style.backgroundColor='#656565'" href="#" @click="handleCashierInvoices">Cashier Invoices</a></li>
            </td>
          </tr>
          <tr>
            <td>
              <li class="list-group-item" v-if="hasPermission(37)"  style="background-color: #656565;border: solid 2px;border-style: outset;text-align:center"><a style="color:whitesmoke"  onmouseover="this.style.backgroundColor='#656565'" href="#" @click="handleCashierCash">Cashier Cash</a></li>
            </td>
            <td>
            </td>
            <td>
            </td>
            <td>
            </td>
          </tr>
        </table>
      </div> -->

  </div>
</template>



<script>
import commonServices from "@/shared/commonServices";
// import ReportsMenu from "@/components/ReportsMenu";
import AppHeader from "@/components/AppHeader.vue";
import axios from "axios";
import Bg from '@/assets/2.jpg'


import img1 from '@/assets/31.png'
import img2 from '@/assets/32.png'
import img3 from '@/assets/33.png'
import img4 from '@/assets/34.png'
import img5 from '@/assets/35.png'
import img6 from '@/assets/36.png'
import img7 from '@/assets/37.png'
import img8 from '@/assets/38.png'
import img9 from '@/assets/39.png'
import img10 from '@/assets/40.png'
import img11 from '@/assets/41.png'
import img12 from '@/assets/42.png'
import img13 from '@/assets/43.png'
import img14 from '@/assets/44.png'
import img15 from '@/assets/45.png'
import img16 from '@/assets/29.png'


export default {
  mixins: [commonServices],
  components: { AppHeader },

  data() {
    return {
      reports: [],
      loading: true,
      Bg,
      imgs: [
        img1, img2, img3, img4, img5,
        img6, img7, img8, img9, img10,
        img11, img12, img13, img14, img15,img16
      ],
    };
  },

  computed: {
    filteredReports() {
      return this.reports.filter((report) =>
        this.hasPermission(report.permissionId)
      );
    },

    containerStyle() {
      if (!this.Bg) return {};
      return {
        backgroundImage: `
          url(${this.Bg})
        `,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        minHeight: '100vh'
      };
    }

  },

  async mounted() {
    this.language = "ar";
    this.handleLanguage();
    await this.fetchReports();
  },

  methods: {
    goBack() {
      if (this.$router) {
        this.$router.back();
      }
    },
    handleMainPage() {
      this.$router.push({ name: "main" });
    },

    handleDailyTotals() {
      this.$router.push({ name: "dailytotal" });
    },

    handleDailySales() {
      this.$router.push({ name: "dailysales" });
    },
    handleCashierInvoices() {
      this.$router.push({ name: "cashierinvoices" });
    },
    handleCashierCash() {
      this.$router.push({ name: "cashiercash" });
    },

    handleItemsDaily() {
      this.$router.push({ name: "itemsdaily" });
    },
  handleAllItemsDaily() {
      this.$router.push({ name: 'allItems'} );
    },
    handleDepItemsDaily() {
      this.$router.push({ name: "itemsdepdaily" });
    },
    async fetchReports() {
      try {
        let dataURL = this.apiURL + "Reports";
        let response = await axios.post(dataURL, this.giftCardJson);
        this.reports = response.data || []; // Ensure response data is an array
        this.loading = false;
      } catch (error) {
        console.error("Error fetching reports:", error);
        this.loading = false;
      }
    },

// getReportIconByName(listName, type = 'default') {
//   const icons = {
//     totalsales: {
//       default: 'data.png',
//       hover: 'data.png'
//     },
//     customers: {
//       default: 'data.png',
//       hover: 'data.png'
//     },
//     dailysales: {
//       default: 'daily.png',
//       hover: 'daily.png'
//     },
//     cashiercash: {
//       default: 'data.png',
//       hover: 'data.png'
//     },
//     cashierinvoices: {
//       default: 'data.png',
//       hover: 'data.png'
//     }
//   };

//   const iconSet = icons[listName?.toLowerCase()] || {
//     default: 'data.png',
//     hover: 'data.png'
//   };

//   return new URL(`../assets/${iconSet[type]}`, import.meta.url).href;
// },


  },
};
</script>

<style scoped>
/* ===== Layout ===== */
.reports-container {
  min-height: 100vh;
  margin-top: -26px;
  background: var(--theme-bg-end);
  /* background: linear-gradient(135deg, var(--theme-bg-start) 0%, var(--theme-bg-end) 100%); */
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(1px);
}

/* ===== Header ===== */
.reports-header {
  background: var(--theme-primary);
  padding: 1rem 2rem;
  box-shadow: 0 6px 25px rgba(92, 107, 192, 0.35);
  position: sticky;
  top: 0;
  z-index: 50;
}


.header-right {
  display: flex;
  justify-content: flex-end;
}

.header-content {
  max-width: 1400px;
  margin: auto;
  display: grid;
  grid-template-columns: auto 1fr auto; /* menu | title | back */
  align-items: center;
  gap: 1.25rem;
}

/* MENU */
.header-menu {
  display: flex;
  align-items: center;
}

/* TITLE */
.header-title {
  text-align: left;
}

/* BACK */
.header-right {
  display: flex;
  justify-content: flex-end;
}
.page-title {
  margin: 0;
  font-size: 2rem;
  font-weight: 800;
  color: white;
}

.page-subtitle {
  margin-top: 0.25rem;
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.95rem;
}

/* ===== Back Button ===== */
.btn-back {
  background: rgba(255, 255, 255, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.25);
  color: white;
  padding: 0.6rem 1.25rem;
  border-radius: 14px;
  font-size: 1.4rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-back:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

/* ===== Content ===== */
.reports-content {
  /* max-width: 1400px; */
  margin: 2rem auto;
  padding: 0 1.5rem;
  color: white;
  border-radius: 24px;
  padding: 2rem;
  width: 80%;
  max-width: 1100px;
  /* box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4); */
  /* border: 1px solid rgba(92, 107, 192, 0.2); */
  animation: fadeInUp 0.6s ease-out;

  /* background:rgba(37, 45, 66, 0.8); */
  /* background:#41578ecc; */

    /* backdrop-filter:  brightness(0.9);
  -webkit-backdrop-filter: blur(8px) brightness(0.6);

  position: relative;
  z-index: 1; */

}

/* reuse section-title from Sales */
.section-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 700;
  font-size: 1.5rem;
  color: #ffffff;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  /* border-bottom: 2px solid rgba(92, 107, 192, 0.3); */
}

/* ===== Grid ===== */
.reports-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 1.4rem;
}

/* reuse menu-card from Sales */
.menu-card {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.75rem 1rem;
  border-radius: 20px;
  border: 2px dashed rgba(255, 255, 255, 0.1);
  color: white;
  cursor: pointer;
  min-height: 150px;
  text-align: center;
  transition: all 0.3s ease;
}

.menu-card:hover {
  /* transform: scale(1.03); */
  box-shadow: 0 12px 40px rgba(92, 107, 192, 0.4);
  background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-secondary) 100%);
  border-color: rgba(255, 255, 255, 0.3);
}

.card-label {
  font-size: 1.5rem;
  font-weight: 600;
  padding-top: 1rem;
}

.link-card {
  text-decoration: none;
}

.card-icon {
  width: 40px;
  height: 40px;
  object-fit: contain;
  display: block;
  max-width: 100%;
  max-height: 100%;
}

/* ===== Card Content Layout ===== */
.menu-card {
  flex-direction: column; /* الصورة فوق والنص تحت */
  gap: 0.75rem;
}

/* ===== Icon Wrapper ===== */
.card-icon-wrapper {
  position: relative;
  width: 48px;
  height: 48px;
}

/* ===== Icons ===== */
.card-icon {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: all 0.45s ease;
}

/* الافتراضية */
.default-icon {
  opacity: 1;
  transform: scale(1);
}

/* صورة الهوفر */
.hover-icon {
  opacity: 0;
  transform: scale(0.6) ;
}

/* ===== Hover Animation ===== */
.menu-card:hover .default-icon {
  opacity: 0;
  transform: scale(1.4) ;
}

.menu-card:hover .hover-icon {
  opacity: 1;
  transform: scale(1);
}

/* Bounce لطيف */
.menu-card:hover .card-icon-wrapper {
  animation: icon-bounce 0.9s ease;
}

@keyframes icon-bounce {
  0%   { transform: translateY(0); }
  40%  { transform: translateY(-6px); }
  100% { transform: translateY(0); }
}

</style>
